import React, { useEffect, useState } from 'react';
import { api } from "../pages/api"; 

const TopSellingProducts = () => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const fetchTopSellingProducts = async () => {
      try {
        const res = await api.get('/api/dash/top-selling');
        setProducts(res.data); // Assuming the API returns an array of products
      } catch (err) {
        console.error('Error fetching top-selling products:', err);
      }
    };

    fetchTopSellingProducts();
  }, []);

  if (!products.length) return <p>Loading...</p>;

  return (
    <div className="card">
      <div className="card-header">
        <h5>Top Selling Products</h5>
      </div>
      <div className="card-body">
        <table className="table table-striped table-bordered">
          <thead>
            <tr>
              <th>Product Name</th>
              <th>Quantity Sold</th>
              <th>Total Revenue</th>
            </tr>
          </thead>
          <tbody>
            {products.map((product) => (
              <tr key={product.item_id}>
                <td>{product.item_name}</td>
                <td>{product.total_sold}</td>
                <td>{product.total_sold}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TopSellingProducts;
